const processNameField = (str) => {
  let processedStr = str.replace(/  +/g, ' ');
  processedStr = processedStr
    .replace(/[^a-zA-Z ]/g, '')
    // .replace(/[^a-zA-Z '-]/g, "") this will allow(- and ')
    .replace(/  +/g, ' ')
    .replace(/--+/g, '-')
    .replace(/''+/g, "'")
    .replace(/(?:- )/g, '-')
    .replace(/(?: -)/g, ' ')
    .replace(/(?:'-)/g, "'")
    .replace(/(?:-')/g, '-')
    .replace(/(?:' )/g, "'")
    .replace(/(?: ')/g, ' ');
  if (processedStr[0] && (processedStr[0] == ' ' || processedStr[0] == '-')) {
    processedStr = processedStr.substring(1);
  }
  return processedStr;
};

const processCityField = (str) => {
  let processedStr = str.replace(/  +/g, ' ');
  processedStr = processedStr
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z -]/g, '')
    .replace(/  +/g, ' ');
  if (processedStr[0] && (processedStr[0] == ' ' || processedStr[0] == '-')) {
    processedStr = processedStr.substring(1);
  }
  return processedStr;
};

const processEmailField = (str) => {
  let processString = '';
  processString = str.replace(/  +/g, ' ');
  if (!processString) {
    return processString;
  }
  let a = 0;
  processString = processString.replace(/[^a-zA-Z0-9._\-@]/g, '');
  processString = processString.replace(
    // ! Dont Delete. Logic cloned and commented to allow __
    // /\-\-|\-\.|\-_|\-@|\.\.|\.\-|\._|__|_\.|_\-|@\-|@\./,
    /\-\-|\-\.|\-_|\.\.|\.\-|\._|_\.|_\-|@\-|@\./,
    (m) => m[0]
  );
  processString = processString.replace(/@/g, (match) =>
    ++a === 2 ? '' : match
  );
  if (['@', '_', '.', '-'].includes(processString[0])) {
    processString = processString.substring(1);
  }
  if (processString.includes('@')) {
    let domain_str = processString.split('@');
    domain_str[1] = domain_str[1].replace(/[^a-zA-Z0-9.\-]/g, '');
    if (domain_str[1].includes('.')) {
      let prefix = domain_str[1].substring(0, domain_str[1].lastIndexOf('.'));
      let suffix = domain_str[1].substring(domain_str[1].lastIndexOf('.'));
      suffix = suffix.replace(/[^a-zA-Z]/g, '');
      domain_str[1] = prefix + '.' + suffix;
    }
    processString = domain_str.join('@');
  }
  return processString;
};

const cleanEmailField = (str) => {
  let temp = str;
  if (temp) {
    if (temp.endsWith('.')) temp = temp.slice(0, -1);
    return temp.trim().toLocaleLowerCase();
  }
  return temp;
};

const cleanNameField = (str) => {
  let temp = str;
  if (temp) {
    if (temp.endsWith('-') || temp.endsWith("'")) temp = temp.slice(0, -1);
    return temp.trim();
  }
  return temp;
};

const addressFormater = (str) => {
  let processString = str.replace(/  +/g, ' ');
  processString = processString
    .replace(/[^A-Za-z0-9\s_,./\\#&`~-]*$/g, '')
    .replace(/^[?!\\]/g, '')
    .replace(/  +/g, ' ')
    .replace(/--+/g, '-')
    .replace(/##+/g, '#')
    .replace(/~~+/g, '~')
    .replace(/``+/g, '`')
    .replace(/,,+/g, ',')
    .replace(/(?: ,)/g, ' ')
    .replace(/(?:- )/g, '-')
    .replace(/(?: -)/g, ' ');
  if (
    processString[0] &&
    (processString[0] == ' ' ||
      processString[0] == '/' ||
      processString[0] == '`' ||
      processString[0] == '~' ||
      processString[0] == ',' ||
      processString[0] == '.' ||
      processString[0] == '-')
  ) {
    processString = processString.substring(1);
  }
  return processString;
};

const phoneNumberLengthValidation = (value) => {
  let numberStrip = value.replace(/\D/g, '');
  let phonenumberlength = numberStrip.length;
  if (numberStrip[0] == 1 ? phonenumberlength < 12 : phonenumberlength < 11) {
    return numberStrip;
  }
  return null;
};
export {
  processNameField,
  cleanNameField,
  phoneNumberLengthValidation,
  addressFormater,
  processEmailField,
  cleanEmailField,
  processCityField,
};
